import {Command} from "../decorators/command.decorator";
import {IssueType} from "../domain/entities/issue-type.entity";
import {CommandName} from "./command-name.enum";
import {AbstractCommand} from "./abstract.command";

/**
 * Command to delete an issue type entity.
 * Accepts the full entity; the transformer extracts the UID for the backend payload.
 */
@Command({type: `delete`, prototype: IssueType})
export class DeleteIssueTypeCommand extends AbstractCommand<IssueType> {

    public name: CommandName = CommandName.DELETE_ISSUE_TYPE;

    public tags = ['entity', 'delete', 'issue-type'];

    constructor(payload: IssueType) {
        super('issue-type', payload.uid, payload);
    }
}
